var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-side"},[_c('Illustration',{attrs:{"blob":require('@/assets/registration/blob.svg'),"illustration":require('@/assets/registration/Sign-in.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }